export enum HubSpotEnrichmentJobTriggerTypeEnum {
  MANUAL = "MANUAL",
  SCHEDULED = "SCHEDULED",
  TRIGGERED = "TRIGGERED",
  INLINE = "INLINE"
}

export const HubSpotEnrichmentJobTriggerTypeNames: Record<HubSpotEnrichmentJobTriggerTypeEnum, string> = {
  [HubSpotEnrichmentJobTriggerTypeEnum.MANUAL]: 'Manual',
  [HubSpotEnrichmentJobTriggerTypeEnum.SCHEDULED]: 'Scheduled',
  [HubSpotEnrichmentJobTriggerTypeEnum.TRIGGERED]: 'On Create',
  [HubSpotEnrichmentJobTriggerTypeEnum.INLINE]: 'Inline',
}
